import { useState } from 'react';
import { faqData } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4 font-label">
            FAQ
          </span>
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 leading-tight">
            Często zadawane pytania
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-4 max-w-xl mx-auto">
            Odpowiedzi na najważniejsze pytania dotyczące USFansSpreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200 rounded-xl overflow-hidden bg-white"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 md:px-6 md:pb-6 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}